export const defaultImage = 'https://static.tickchak.co.il/all/defaultImage.png';
